import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'parseSeconds',
    standalone: true,
})

export class ParseSecondsPipe implements PipeTransform {
    transform(value: number): string {
        if (!value || value === 0) return '0s';

        const totalSeconds = Math.floor(value);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        const parts: string[] = [];

        if (hours > 0 && minutes === 0 && seconds === 0) {
            return `${hours}h`; // Only hours
        }

        if (hours > 0) parts.push(`${hours}h`);
        if (minutes > 0) parts.push(`${minutes}m`);
        if (seconds > 0 && hours === 0) parts.push(`${seconds}s`); // Show seconds only if no hour

        return parts.join(' ') || '0s';
    }
}